import { AddressMeta } from "../components/form/types";

export function stringifyAddressFinder({
  address_line_1,
  address_line_2,
  suburb,
  city,
  postcode,
  country,
}: AddressMeta) {
  const newAddress: string[] = [];
  [
    address_line_1,
    address_line_2,
    suburb,
    `${city}${postcode ? ` ${postcode}` : ""}`,
    country,
  ].forEach((line) => {
    if (line) {
      newAddress.push(line);
    }
  });

  return newAddress.join(", ");
}
